<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">Add/Edit Activity Log Entry</div>
							<!--Header-->
							<div class="page_main">
								<el-form ref="form" :model="info" label-position="top" class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left Side -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													{{ info.priority }}
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator }}
												</div>
											</el-form-item>
										</div>
										<!-- Right Side -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Received Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Description of the issue, concern, idea, or opportunity" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
								</el-form>
								<div class="file-panel">
									<div class="panel-header">
										<div class="table-title">Investigation Activity Log</div>
									</div>
									<el-table :data="investigationLogs" border stripe
										header-cell-class-name="table-header-cell" class="file-table"
										empty-text="No investigation activity logs">
										<el-table-column prop="description" label="Description" min-width="260" sortable />
										<el-table-column prop="" label="Created Time" min-width="120" sortable>
											<template #default="scope">
												{{ initTime(scope.row.update_time) }}
											</template>
										</el-table-column>
										<el-table-column prop="" label="Last Updated" min-width="140" sortable>
											<template #default="scope">
												{{ initTime(scope.row.dateline) }}
											</template>
										</el-table-column>
										<el-table-column prop="attachment" label="Attachments" min-width="160">
											<template #default="scope">
												<div v-for="(value, index) in scope.row.filelist" :key="index" style="padding: 4px 0;">
													<a :href="value.url" target="_blank">{{ value.name }}</a>
												</div>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<div class="tip-box">
									Please describe the activity in detail and upload any necessary attachments.
								</div>
								<!-- Description Input -->
								<div class="form-item full">
									<div class="label">Description<span class="required">*</span></div>
									<el-input v-model="description" type="textarea" :rows="5" resize="vertical" placeholder="" />
								</div>

								<div class="file-panel">
									<div class="panel-header">
										<div class="table-title">Activity Log Entry Attachments</div>
									</div>
									<el-table :data="attachments" border stripe
										header-cell-class-name="table-header-cell" class="file-table"
										empty-text="No activity log entry attachments">
										<el-table-column prop="" label="Description" sortable min-width="200">
											<template slot-scope="scope">
												<div>{{ scope.row.description || "/" }}</div>
											</template>
										</el-table-column>
										<el-table-column prop="fileName" label="File Name" min-width="240">
											<template slot-scope="scope">
												<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
											</template>
										</el-table-column>
										<el-table-column prop="id" label="Actions" width="80" align="center">
											<template #default="scope">
												<div class="inline_btn">
													<el-button type="danger" size="mini"
														@click="handleRemove(scope.row)">
														Delete
													</el-button>
												</div>
											</template>
										</el-table-column>
									</el-table>
									<el-button type="primary" size="small" class="add-attachment-btn"
										@click="handleAddAttachment">
										Add Activity Log Entry Attachment
									</el-button>
								</div>
								<!-- Bottom Buttons -->
								<div class="footer-actions">
									<el-button type="primary" size="small" @click="handleSave">
										Save
									</el-button>
									<el-button type="primary" size="small" @click="handleCancel">
										Cancel
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--Add File Dialog-->
		<el-dialog title="Add Activity Log Entry Attachment" :visible.sync="dialogVisible" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description">
							<el-input v-model="ruleForm.description" type="textarea" :rows="5" resize="none"
								placeholder="Please enter a description" />
						</el-form-item>
						<!-- Attachments -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span> Pending Upload Files </span>
									<span class="upload-limit"> （(Max 10 MB) </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/"
										name="files"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange"
										:limit="1"
										:with-credentials="true"
										:auto-upload="false"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No file selected" }}
										<span v-if="fileName" style="position: absolute; right: 20px; top: 12px; cursor: pointer;color: #f00;" @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--Add File Dialog-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail
} from "@/api/docManage/changeRequest/index";
import {
	capaActivityLogAdd,
	capaUploadsActivityLogFile,
	capaUploadsActivityLogFileDel,
	capaActivityLogDetail
} from "@/api/capaManage/capaRequest/index";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from "moment";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			dialogVisible: false,
			keyword: "",
			searchKeyword: "",
			selectedFile: null,
			fileName: "",
			info: {},
			investigationLogs: [],
			attachments: [],
			userToken: localStorage.getItem("userToken"),
			activityId: null,
			description: '',
			ruleForm: {
				id: "",
				description: "",
				fileUrl: "",
			},
			rules: {
				description: [{
					required: true,
					message: "Please enter comments",
					trigger: "blur"
				}, ],
			},
		};
	},
	mounted() {
		let that = this;
		if(that.$route.query.id) {
			that.activityId = that.$route.query.id;
		}
		that.getPageInfo();
		that.isLoading = false;
	},
	methods: {
		//Get Page Information
		getPageInfo() {
			let that = this;
			resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					// console.log(res.data);
					that.info = {
						id: res.data.id,
						request_id: res.data.request_id,
						status_name: res.data.status_name,
						priority: res.data.priority,
						investigator: res.data.investigator,
						description: res.data.description,
						username: res.data.username,
						// company_name: res.data.company_name,
						source_type: res.data.source_type,
						departments_name: res.data.departments_name,
						source_info: res.data.source_info,
						time1: res.data.time1,
						time2: res.data.time2,
						time3: res.data.time3,
					};
					that.investigationLogs = res.data.capaaffected_list;
					if(that.activityId) {
						//Get Attachment Details
						capaActivityLogDetail({ id: that.activityId }).then(res2 => {
							if(res2.code == 200) {
								that.activityId = res2.data.id;
								that.description = res2.data.description;
								that.attachments = res2.data.filelist;
							}
						});
					}
				}
			});
		},
		handleAvatarChange(file, fileList) {
			let that = this;
			if (!file && !fileList) return;
			that.selectedFile = file.raw;
			that.fileName = file.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if (!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10 MB");
				return false;
			}
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
		},
		// Delete File
		delFile() {
			let that = this;
			that.selectedFile = null;
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		initTime(value) {
			return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');
		},
		// Add Activity Log Entry Attachment
		handleAddAttachment() {
			let that = this;
			if (!that.description.trim()) {
				that.$message.warning("Please enter a description");
				return;
			}
			capaActivityLogAdd({
				capa_id: that.info.id,
				description: that.description,
				id: that.activityId ? that.activityId : ''
			}).then(res => {
				if(res.code == 200) {
					that.activityId = res.data;
					that.dialogVisible = true;
				}
			});
		},
		//Save
		handleSave() {
			let that = this;
			if (!that.description.trim()) {
				that.$message.warning("Please enter a description");
				return;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
			capaActivityLogAdd({
				capa_id: that.info.id,
				description: that.description,
				id: that.activityId ? that.activityId : ''
			}).then(res => {
				if(res.code == 200) {
					that.$toast.clear();
					that.$message.success('Operation successful');
					setTimeout(() => {
						window.location.reload();
					}, 800);
				}
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//Upload Attachment
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					if (!that.selectedFile) {
						that.$message.warning("Please upload a file");
						return false;
					}
					that.$toast.loading({ duration: 0, forbidClick: true });
					const formData = new FormData();
					formData.append('files', that.selectedFile);
					formData.append('description', that.ruleForm.description);
					formData.append('capa_id', that.info.id);
					formData.append('activity_log_id', that.activityId);
					formData.append('id', '');
					capaUploadsActivityLogFile(formData).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				} else {
					return false;
				}
			});
		},
		//Remove Attachment
		handleRemove(value) {
			let that = this;
			that.$confirm("Are you sure you want to delete this attachment?？", "Notice", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsActivityLogFileDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			}).catch(() => {});
		}
	},
};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}
			}
		}
	}

	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label Style */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* Unified Input Style */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.required {
		color: #f56c6c;
		margin-left: 2px;
	}

	.tip-box {
		margin: 24px 0 16px;
		padding: 12px 8px;
		background: #fff7e8;
		border-radius: 4px;
		color: #222;
		font-weight: 600;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.add-attachment-btn {
		margin: 10px;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.footer-actions {
		margin-top: 28px;
		text-align: center;
	}

	.footer-actions .el-button {
		padding: 7px 13px;
	}
</style>